export class FrontPageNotifications {
    constructor(src, _responseContext) {
        this.HasExpiringOrganizations = src.HasExpiringOrganizations;
        this.HasInvalidMunicipalities = src.HasInvalidMunicipalities;
        this.HasDeceasedActivePersons = src.HasDeceasedActivePersons;
        this.HasNewCeremonies = src.HasNewCeremonies;
        this.HasPolitikerToHandle = src.HasPolitikerToHandle;
    }
}
